var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _polygon2, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195 145.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m146.1 59.4h-5.7v3.8c0 2.6-2.1 4.7-4.6 4.7h-3.3c-2.6 0-4.6-2.1-4.6-4.7v-3.8h-9.5v3.8c0 2.6-2.1 4.7-4.6 4.7h-3.3c-2.6 0-4.6-2.1-4.6-4.7v-3.8h-9.5v3.8c0 2.6-2.1 4.7-4.6 4.7h-3.3c-2.6 0-4.6-2.1-4.6-4.7v-3.8h-9.5v3.8c0 2.6-2.1 4.7-4.6 4.7h-3.3c-2.6 0-4.6-2.1-4.6-4.7v-3.8h-8.6c-2.2 0-3.9 1.8-3.9 4v11.3h99.8v-11.4c0-1.9-1.3-3.5-3.1-3.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m154.6 117c1 0 1.8-0.8 1.8-1.8v-52c0-4.1-3.3-7.4-7.4-7.4h-8.7v-1.5c0-2.5-2.1-4.6-4.6-4.6h-3.3c-2.5 0-4.6 2.1-4.6 4.6v1.5h-9.5v-1.5c0-2.5-2.1-4.6-4.6-4.6h-3.3c-2.5 0-4.6 2.1-4.6 4.6v1.5h-9.5v-1.5c0-2.5-2.1-4.6-4.6-4.6h-3.3c-2.5 0-4.6 2.1-4.6 4.6v1.5h-9.5v-1.5c0-2.5-2.1-4.6-4.6-4.6h-3.3c-2.5 0-4.6 2.1-4.6 4.6v1.5h-8.8c-4.1 0-7.4 3.3-7.4 7.4v74.8c0 4.1 3.3 7.4 7.4 7.4h95.9c4.1 0 7.5-3.3 7.5-7.3v-14.7c0-1-0.8-1.7-1.8-1.7s-1.8 0.8-1.8 1.7v14.6c0 2.1-1.8 3.8-3.9 3.8h-95.9c-2.1 0-3.9-1.7-3.9-3.9v-60.3h103.7v37.6c0 1 0.8 1.8 1.8 1.8zm-18.9-63.6c0.6 0 1 0.4 1 1v8.3c0 0.5-0.5 1-1 1h-1.3v-8.7c0-0.6-0.2-1.1-0.4-1.6h1.7zm-22 0c0.6 0 1 0.4 1 1v8.3c0 0.5-0.5 1-1 1h-1.3v-8.7c0-0.6-0.2-1.1-0.4-1.6h1.7zm-22.1 0c0.6 0 1 0.4 1 1v8.3c0 0.5-0.5 1-1 1h-1.3v-8.7c0-0.6-0.2-1.1-0.4-1.6h1.7zm-21.9 0c0.6 0 1 0.4 1 1v8.3c0 0.5-0.5 1-1 1h-1.3v-8.7c0-0.6-0.2-1.1-0.4-1.6h1.7zm83 21.3h-103.3v-11.3c0-2.2 1.7-4 3.9-4h8.6v3.8c0 2.6 2 4.7 4.6 4.7h3.3c2.5 0 4.6-2.1 4.6-4.7v-3.8h9.5v3.8c0 2.6 2 4.7 4.6 4.7h3.3c2.5 0 4.6-2.1 4.6-4.7v-3.8h9.5v3.8c0 2.6 2 4.7 4.6 4.7h3.3c2.5 0 4.6-2.1 4.6-4.7v-3.8h9.5v3.8c0 2.6 2 4.7 4.6 4.7h3.3c2.5 0 4.6-2.1 4.6-4.7v-3.8h8.6c2.1 0 3.9 1.8 3.9 4v11.3h-0.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m53.7 29.8c-0.5 0-1 0.4-1 1v2.2c0 0.5 0.4 1 1 1s1-0.4 1-1v-2.2c-0.1-0.6-0.5-1-1-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m51.2 27.6h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c0.5 0 1-0.4 1-1s-0.5-1-1-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m53.7 23c-0.5 0-1 0.4-1 1v2.2c0 0.5 0.4 1 1 1s1-0.4 1-1v-2.2c-0.1-0.6-0.5-1-1-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m58.4 27.4h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c0.5 0 1-0.4 1-1s-0.5-1-1-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m185.5 133c-0.8 0-1.5 0.7-1.5 1.6v3.8c0 0.9 0.7 1.6 1.5 1.6s1.5-0.7 1.5-1.6v-3.8c0-0.9-0.7-1.6-1.5-1.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m181.4 129h-3.8c-0.9 0-1.6 0.7-1.6 1.5s0.7 1.5 1.6 1.5h3.8c0.9 0 1.6-0.7 1.6-1.5s-0.7-1.5-1.6-1.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m185.5 121c-0.8 0-1.5 0.7-1.5 1.6v3.8c0 0.9 0.7 1.6 1.5 1.6s1.5-0.7 1.5-1.6v-3.8c0-0.9-0.7-1.6-1.5-1.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m193.4 129h-3.8c-0.9 0-1.6 0.7-1.6 1.5s0.7 1.5 1.6 1.5h3.8c0.9 0 1.6-0.7 1.6-1.5s-0.7-1.5-1.6-1.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent1RATE",
    d: "m9.6 112s1.3 9.3-9.6 9.1c0 0 9.3 0.1 9.1 8.8 0 0 0.8-6.9 9.4-8.4 0 0-7.2 1.7-8.9-9.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent1RATE",
    d: "m170.6 60s1.3 9.3-9.6 9.1c0 0 9.3 0.1 9.1 8.8 0 0 0.8-6.9 9.4-8.4 0 0-7.2 1.7-8.9-9.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m31.3 78s0.5 3.2-3.3 3.2c0 0 3.3 0 3.2 3.1 0 0 0.3-2.4 3.3-2.9 0-0.1-2.6 0.5-3.2-3.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m97.3 0s0.5 3.2-3.3 3.2c0 0 3.3 0 3.2 3.1 0 0 0.3-2.4 3.3-2.9-0.1-0.1-2.6 0.5-3.2-3.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m127 35c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-5c-1.1 0-2 0.9-2 2s0.9 2 2 2 2-0.9 2-2-0.9-2-2-2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent1RATE",
    d: "M6.5,47C5.1,47,4,45.9,4,44.5S5.1,42,6.5,42S9,43.1,9,44.5S7.9,47,6.5,47z M6.5,43C5.7,43,5,43.7,5,44.5   S5.7,46,6.5,46S8,45.3,8,44.5S7.3,43,6.5,43z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "calendarAccent1RATE",
    points: "98 116.1 111 95.2 115.4 98.6 98.8 125.2 86.4 111.9 90.2 107.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "calendarIllSecondaryRATE",
    points: "98 116.1 111 95.2 115.4 98.6 98.8 125.2 86.4 111.9 90.2 107.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m91.6 53.4h-1.7c0.3 0.5 0.4 1 0.4 1.6v8.7h1.3c0.6 0 1-0.4 1-1v-8.3c0-0.6-0.4-1-1-1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m69.7 53.4h-1.7c0.3 0.5 0.4 1 0.4 1.6v8.7h1.3c0.6 0 1-0.4 1-1v-8.3c0-0.6-0.4-1-1-1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m113.7 53.4h-1.7c0.3 0.5 0.4 1 0.4 1.6v8.7h1.3c0.6 0 1-0.4 1-1v-8.3c0-0.6-0.4-1-1-1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m135.7 53.4h-1.7c0.3 0.5 0.4 1 0.4 1.6v8.7h1.3c0.6 0 1-0.4 1-1v-8.3c0-0.6-0.4-1-1-1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "calendarIllSecondaryRATE",
    d: "m146.1 59.4c-0.3-0.1-0.5-0.1-0.8-0.1h-8.6v0.1h9.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "calendarAccent2RATE",
    d: "m50.2 140.7c0.7 0.7 1.7 1.1 2.7 1.1h9.1l-0.1-0.1c-3-2.4-4.8-5.8-4.8-10.2v-40.6c-0.1-5.7 3.2-10.8 8-13.2 0 0 0.2-0.1 0.1-0.1h-16.1v60.4c0 1 0.4 2 1.1 2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/Calender_Icon.5789df6ecd4d7fb10726305841922ea8.svg";
export { ForwardRef as ReactComponent };